module.exports = {"title":"Anmelden","loginButton":"Anmelden","password":"Passwort","notRegistered":"Noch nicht bei OMyFu?","registerForFree":"Kostenlos registrieren","lostPassword":"Passwort vergessen?","meta":"Log in"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/login.json
// module id = dJph
// module chunks = 1